import { Operation } from "../types/Types";

export const isPayed = (operation: Operation): boolean =>
  operation.payedAt != "";
